import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    errorTitle: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Sheet title shown at the top of the Dev Tools panel */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DevToolsSheet.title?c=24xcwi5emlhgd", defaultMessage: "Dev Tools" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message shown when the Dev Tools sheet fails to load */
            errorTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DevToolsSheet.errorTitle?c=3hysb3djkf1u6", defaultMessage: "Something went wrong" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
